// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lJSON2 {
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: var(--spacing-3);
}

.LqrzoO {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
  color: var(--text-neutral-dark);
  text-align: center;
  overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/SwapPartnershipDisclosure/SwapPartnershipDisclosure.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":[".footer {\n  width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  padding: var(--spacing-3);\n}\n\n.text {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: 20px;\n  color: var(--text-neutral-dark);\n  text-align: center;\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `lJSON2`,
	"text": `LqrzoO`
};
module.exports = ___CSS_LOADER_EXPORT___;
